import {
    getPropertyTypes,
    getAllPropertyTypes,
    deletePropertyType,
    createPropertyType,
    updatePropertyType
} from '../../../services/PropertyTypeService';
import {
    CONFIRMED_GET_PROERTY_TYPES
} from './PropertyTypeTypes';

export function getPropertyTypesAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_PROPERTY_TYPES_LOADING', payload: true });
        getPropertyTypes(currentPage, pageSize, searchTerm, filterQuery).then((response) => {
            dispatch(confirmedGetPropertyTypesAction(response.data.data));
        }).finally(() => {
            dispatch({ type: 'SET_PROPERTY_TYPES_LOADING', payload: false });
        });
    };
}

export function getAllPropertyTypesAction() {
    return (dispatch) => {
        getAllPropertyTypes().then((response) => {
            dispatch(confirmedGetPropertyTypesAction(response.data.data));
        });
    };
}

export function confirmedGetPropertyTypesAction(data) {
    return {
        type: CONFIRMED_GET_PROERTY_TYPES,
        payload: data,
    };
}

export function deletePropertyTypeAction(id, history) {
    return (dispatch, getState) => {
        return deletePropertyType(id).then((response) => {
            return response;
        });
    };
}

export function createPropertyTypeAction(data) {
    return () => {
        return createPropertyType(data).then((response) => {
            return response;
        });
    };
}

export function updatePropertyTypeAction(id, data) {
    return () => {
        return updatePropertyType(id, data).then((response) => {
            return response;
        });
    };
}

